var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nightsky-background"},[_c('canvas',{ref:"canvas",staticClass:"stars-canvas"}),_c('div',{staticClass:"shooting-wrapper"},[_c('div',{ref:"starContainer",staticClass:"shooting-container"})])])}
var staticRenderFns = []

export { render, staticRenderFns }